/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2020-07-26 17:45:15
 */
export default {
  REJECTED: 'rejected',
  REFUSED: 'refuse',
  PENDING: 'pending',
  APPROVED: 'approved',
  UNCOMMITTED: 'uncommitted'
}



// WEBPACK FOOTER //
// ./src/model/auditStatus.js